import { Controller } from '@hotwired/stimulus';
import flatpickr from 'flatpickr';
import { Lithuanian } from 'flatpickr/dist/l10n/lt.js';
import { english } from 'flatpickr/dist/l10n/default.js';
import { Russian } from 'flatpickr/dist/l10n/ru.js';

export default class extends Controller {
    connect() {
        let options = {
            locale: this.getLocale(),
            dateFormat: 'Y-m-d'
        };

        const additionalConfig = this.element.dataset.config ? JSON.parse(this.element.dataset.config) : {};

        if (this.element.dataset.disableWeekends) {
            options.disable = [
                function (date) {
                    return (date.getDay() === 0 || date.getDay() === 6);
                }
            ];
        }

        const config = {...options, ...additionalConfig};
        const datepicker = flatpickr(this.element, config);
        this.checkWorkoutType(datepicker, config);
    }

    getLocale() {
        switch (document.documentElement.lang.split('-')[0]) {
            case 'lt':
                return Lithuanian;
            case 'en':
                return english;
            case 'ru':
                return Russian;
            default:
                return Lithuanian;
        }
    }

    checkWorkoutType(datepicker, config) {
        const select = document.querySelector('select[name="workout_type"]');

        if (select) {
            select.addEventListener('change', () => {
                if (select.value === 'with_coach') {
                    datepicker.set('minDate', select.dataset.minDate);
                } else {
                    datepicker.set('minDate', config.minDate);
                }
            });
        }
    }
}
